import _ from 'lodash';
import get from 'lodash/get';
import { formConstants } from '../../../components/utils/constants/form-constants';
import { isEmpty, deepCopyObject } from '../../../components/utils/obj-utils';
import { formMessageConstants } from '../../../components/utils/constants/form-message-constants';
import { formDateConstants } from '../../../components/utils/constants/form-date-constants';
import { fileState } from '../../../components/utils/file-state';
import { orderType } from '../../../components/utils/order-type';
import { getDateAsISOString, createDateFromExisting } from '../../../components/utils/date-utils';
import { ssoFormTypes } from '../../../components/utils/form-types';
import { domainConstants } from '../../../components/utils/constants/domain-constants';
import {
    isNullOrUndefined,
    hasValue
} from '../../../../../general/js/general-helpers';
import userService from '../../../../../general/js/user/user-service';
import {
    getUserDetailsForSaveToAddressBookRequest,
    getSaveUserToAddressBookRequestModel
} from './data-format-helper-dotdigital';
import { currencyIsoCodes } from '../../../../../general/js/basket/currency-helper';
import { MembershipTypes } from '../../../../../general/js/utils';

export function getFormattedUserRegistrationData(userRegistrationData) {
    const { membership } = userRegistrationData;

    if (membership === MembershipTypes.OneClub) {
        return getFormattedOneClubUserRegistrationData(userRegistrationData);
    }

    if (userService.hasTicketingAccount(userRegistrationData)) {
        if (userRegistrationData[formConstants.raMemberId] === null || userRegistrationData[formConstants.raMemberId] === undefined) {
            return getFormattedTicketingRegistrationData(userRegistrationData);
        }
        return getFormattedRaMembersRegistrationData(userRegistrationData);
    }

    return getFormattedDefaultUserRegistrationData(userRegistrationData);
}

function getFormattedOneClubUserRegistrationData(userRegistrationData) {
    const { membership } = userRegistrationData;
    const selectedVenues = userRegistrationData[formConstants.venues];
    const selectedFavoritePlayer = userRegistrationData[formConstants.favoritePlayer];

    let activeMemberships;
    if (userRegistrationData.mastercard) {
        activeMemberships = `${membership};${MembershipTypes.OneClubAdvantage}`;
    } else {
        activeMemberships = membership;
    }

    return {
        password: userRegistrationData[formConstants.password],
        reCaptcha: userRegistrationData[formConstants.reCaptcha],
        formType: userRegistrationData[formConstants.registerFormData][formConstants.formType],
        user: {
            membership: activeMemberships,
            title: userRegistrationData[formConstants.title],
            email: getFormattedEmailRemoveSpaces(userRegistrationData[formConstants.emailAddress]),
            firstName: userRegistrationData[formConstants.firstName],
            lastName: userRegistrationData[formConstants.lastName],
            addresses: [{
                postcode: userRegistrationData[formConstants.postcode],
                country: userRegistrationData[formConstants.country],
                county: userRegistrationData[formConstants.county],
                state: userRegistrationData[formConstants.state],
                main: true,
                shippingAddress: true,
                billingAddress: true
            }],
            mobilePhone: getMobilePhone(userRegistrationData),
            countryCodeMobilePhonePrefix: getCountryCodeMobilePhonePrefix(userRegistrationData),
            currentWebsite: userRegistrationData[formConstants.ssoDomain],
            dateOfBirth: userRegistrationData[formConstants.dateOfBirth] ? userRegistrationData[formConstants.dateOfBirth].toISOString() : null,
            optIns: {
                optedTheOpenOffersByEmail: !userRegistrationData[formConstants.refuseOffers],
                optedPartnerOffersByEmail: userRegistrationData[formConstants.acceptOffers],
                agreedToTermsAndConditions: userRegistrationData[formConstants.oneClubTermsAndServices],
                agreedToPrivacyPolicy: userRegistrationData[formConstants.oneClubTermsAndServices]
            },
            interests: {
                favoritePlayer: _.isEmpty(selectedFavoritePlayer) ? formMessageConstants.emptyString : selectedFavoritePlayer,
                venues: _.isEmpty(selectedVenues) ? [] : selectedVenues
            },
            preferences: {
                championships: getDefaultChampionships(userRegistrationData.registerFormData),
                interests: getDefaultInterests(userRegistrationData.registerFormData)
            },
            zoneInfo: getUserZoneInfo(userRegistrationData.registerFormData),
        }
    };
}

function getFormattedTicketingRegistrationData(userRegistrationData) {
    const { membership } = userRegistrationData;
    let formType = 0;
    if (userRegistrationData[formConstants.registerFormData] === null || userRegistrationData[formConstants.registerFormData] === undefined) {
        formType = ssoFormTypes.TicketingRegister;
    } else {
        formType = userRegistrationData[formConstants.registerFormData][formConstants.formType] == null ? ssoFormTypes.TicketingRegister : userRegistrationData[formConstants.registerFormData][formConstants.formType];
    }

    let activeMemberships;
    if (userRegistrationData.mastercard) {
        activeMemberships = `${membership};${MembershipTypes.OneClubAdvantage}`;
    } else {
        activeMemberships = membership;
    }

    return {
        password: userRegistrationData[formConstants.password],
        reCaptcha: userRegistrationData[formConstants.reCaptcha],
        formType,
        user: {
            membership: activeMemberships,
            title: userRegistrationData[formConstants.title],
            email: getFormattedEmailRemoveSpaces(userRegistrationData[formConstants.emailAddress]),
            firstName: userRegistrationData[formConstants.firstName],
            lastName: userRegistrationData[formConstants.lastName],
            addresses: [{
                addressLine1: userRegistrationData[formConstants.addressLine1],
                addressLine2: userRegistrationData[formConstants.addressLine2],
                addressLine3: userRegistrationData[formConstants.addressLine3],
                postcode: userRegistrationData[formConstants.postcode],
                city: userRegistrationData[formConstants.city],
                country: userRegistrationData[formConstants.country],
                county: userRegistrationData[formConstants.county],
                state: userRegistrationData[formConstants.state],
                main: true,
                shippingAddress: true,
                billingAddress: true
            }],
            mobilePhone: getMobilePhone(userRegistrationData),
            countryCodeMobilePhonePrefix: getCountryCodeMobilePhonePrefix(userRegistrationData),
            currentWebsite: userRegistrationData[formConstants.ssoDomain],
            dateOfBirth: userRegistrationData[formConstants.dateOfBirth] ? userRegistrationData[formConstants.dateOfBirth].toISOString() : null,
            optIns: {
                optedTheOpenOffersByEmail: !userRegistrationData[formConstants.refuseOffers],
                optedPartnerOffersByEmail: userRegistrationData[formConstants.acceptOffers],
                agreedToTermsAndConditions: userRegistrationData[formConstants.oneClubTermsAndServices],
                agreedToPrivacyPolicy: userRegistrationData[formConstants.privacyPolicy]
            },
            preferences: {
                championships: getDefaultChampionships(userRegistrationData),
                interests: getDefaultInterests(userRegistrationData)
            }
        }
    };
}

function getFormattedRaMembersRegistrationData(userRegistrationData) {
    const { membership } = userRegistrationData;
    return {
        password: userRegistrationData[formConstants.password],
        user: {
            membership,
            title: userRegistrationData[formConstants.title],
            email: userRegistrationData[formConstants.emailAddress].toLowerCase(),
            firstName: userRegistrationData[formConstants.firstName],
            lastName: userRegistrationData[formConstants.lastName],
            addresses: [{
                addressLine1: userRegistrationData[formConstants.addressLine1],
                addressLine2: userRegistrationData[formConstants.addressLine2],
                addressLine3: userRegistrationData[formConstants.addressLine3],
                postcode: userRegistrationData[formConstants.postcode],
                city: userRegistrationData[formConstants.city],
                country: userRegistrationData[formConstants.country],
                county: userRegistrationData[formConstants.county],
                state: userRegistrationData[formConstants.state],
                main: true,
                shippingAddress: true,
                billingAddress: true
            }],
            mobilePhone: getMobilePhone(userRegistrationData),
            raMemberId: userRegistrationData[formConstants.raMemberId],
            countryCodeMobilePhonePrefix: getCountryCodeMobilePhonePrefix(userRegistrationData),
            currentWebsite: userRegistrationData[formConstants.ssoDomain],
            dateOfBirth: userRegistrationData[formConstants.dateOfBirth] ? userRegistrationData[formConstants.dateOfBirth].toISOString() : null,
            optIns: {
                optedTheOpenOffersByEmail: !userRegistrationData[formConstants.refuseOffers],
                optedPartnerOffersByEmail: userRegistrationData[formConstants.acceptOffers],
                agreedToTermsAndConditions: true,
                agreedToPrivacyPolicy: userRegistrationData[formConstants.privacyPolicy]
            },
            preferences: {
                championships: getDefaultChampionships(userRegistrationData),
                interests: getDefaultInterests(userRegistrationData)
            },
            zoneInfo: getUserZoneInfo(userRegistrationData.registerFormData)
        }
    };
}

function getFormattedDefaultUserRegistrationData(userRegistrationData) {
    const { membership } = userRegistrationData;
    const formType = userRegistrationData[formConstants.formType] == null ? ssoFormTypes.DefaultRegister : userRegistrationData[formConstants.formType];

    let activeMemberships;
    if (userRegistrationData.mastercard) {
        activeMemberships = `${membership};${MembershipTypes.OneClubAdvantage}`;
    } else {
        activeMemberships = membership;
    }

    return {
        password: userRegistrationData[formConstants.password],
        reCaptcha: userRegistrationData[formConstants.reCaptcha],
        formType,
        user: {
            membership: activeMemberships,
            email: getFormattedEmailRemoveSpaces(userRegistrationData[formConstants.emailAddress]),
            firstName: userRegistrationData[formConstants.firstName],
            lastName: userRegistrationData[formConstants.lastName],
            currentWebsite: userRegistrationData[formConstants.ssoDomain],
            mobilePhone: getMobilePhone(userRegistrationData),
            countryCodeMobilePhonePrefix: getCountryCodeMobilePhonePrefix(userRegistrationData),
            optIns: {
                optedTheOpenOffersByEmail: !userRegistrationData[formConstants.refuseOffers],
                optedPartnerOffersByEmail: userRegistrationData[formConstants.acceptOffers],
                agreedToTermsAndConditions: userRegistrationData[formConstants.oneClubTermsAndServices],
                agreedToPrivacyPolicy: userRegistrationData[formConstants.oneClubTermsAndServices]
            },
            preferences: {
                championships: getDefaultChampionships(userRegistrationData),
                interests: getDefaultInterests(userRegistrationData)
            }
        }
    };
}

export function getFormattedUserForgotPasswordData(userForgotPasswordData) {
    return {
        emailAddress: getFormattedEmailRemoveSpaces(userForgotPasswordData[formConstants.emailAddress]),
        website: userForgotPasswordData.website
    };
}

export function getFormattedUserEmailData(emailAddress, ssoDomain) {
    return { userEmail: getFormattedEmailRemoveSpaces(emailAddress), website: ssoDomain };
}

export function getFormattedUserResetPasswordData(userResetPasswordData) {
    return {
        emailAddress: getFormattedEmailRemoveSpaces(userResetPasswordData[formConstants.emailAddress]),
        confirmationCode: userResetPasswordData[formConstants.verificationCode],
        newPassword: userResetPasswordData[formConstants.password],
    };
}

export function getFormattedUserSignInData(userSignInData) {
    const userName = userSignInData[formConstants.userName];
    const formattedUserName = userName || getFormattedEmailRemoveSpaces(userSignInData[formConstants.emailAddress]);

    return {
        username: formattedUserName,
        password: userSignInData[formConstants.password]
    };
}

export function getFormattedUserDataForUpgradeToTicketingAccount(ssoDomain, currentUser, userDetails) {
    const formType = userDetails[formConstants.formType] == null ? ssoFormTypes.UpgradeToTicketingAccount : userDetails[formConstants.formType];
    const reCaptcha = userDetails[formConstants.reCaptcha];
    currentUser.title = userDetails[formConstants.title];
    currentUser.dateOfBirth = userDetails[formConstants.dateOfBirth] ? userDetails[formConstants.dateOfBirth].toISOString() : null;

    currentUser.addresses = updateMainAddress(userDetails, currentUser.addresses);

    currentUser.mobilePhone = getMobilePhone(userDetails);
    currentUser.countryCodeMobilePhonePrefix = getCountryCodeMobilePhonePrefix(userDetails);

    currentUser.interests = updateInterests(userDetails, currentUser.interests);

    return { user: currentUser, formType, reCaptcha };
}

function updateInterests(userDetails, existingInterests) {
    if (!existingInterests) {
        existingInterests = {
            favoritePlayer: '',
            venues: []
        };
    }

    const selectedFavoritePlayer = userDetails[formConstants.favoritePlayer] || existingInterests.favoritePlayer;
    const selectedVenues = userDetails[formConstants.venues] || existingInterests.venues;

    return {
        favoritePlayer: _.isEmpty(selectedFavoritePlayer) ? formMessageConstants.emptyString : selectedFavoritePlayer,
        venues: _.isEmpty(selectedVenues) ? [] : selectedVenues
    };
}

export function getFormattedUserDataForUpgradeToOneClubAccount(currentUser, userDetails) {
    const { activeMemberships } = userDetails;

    const uniqueMemberships = addMembershipType(activeMemberships, MembershipTypes.OneClub);
    const formType = getUpgradeToOneClubFormType(userDetails);
    const reCaptcha = get(userDetails, formConstants.reCaptcha, undefined);

    // Data to upgrade from ticketing to one club
    currentUser.interests = updateInterests(userDetails, currentUser.interests);

    // Data to upgrade from default to one club
    currentUser.membership = uniqueMemberships;
    currentUser.title = userDetails[formConstants.title] || currentUser[formConstants.title];
    currentUser.dateOfBirth = userDetails[formConstants.dateOfBirth] ? userDetails[formConstants.dateOfBirth].toISOString() : currentUser[formConstants.dateOfBirth];
    currentUser.addresses = updateMainAddress(userDetails, currentUser.addresses);

    currentUser.mobilePhone = getMobilePhone(userDetails);
    currentUser.countryCodeMobilePhonePrefix = getCountryCodeMobilePhonePrefix(userDetails);

    currentUser.optIns.agreedToTermsAndConditions = userDetails.oneClubTermsAndServices;
    currentUser.optIns.agreedToPrivacyPolicy = userDetails.oneClubTermsAndServices;

    return { user: currentUser, formType, reCaptcha };
}

export function getFormattedUserDetailsData(userRegistrationData, accountData) {
    const { membership } = accountData;
    const copyOfAccountData = deepCopyObject(accountData);

    copyOfAccountData.addresses = updateMainAddress(userRegistrationData, copyOfAccountData.addresses);

    const optedTheOpenOffersByEmail = !userRegistrationData[formConstants.refuseOffers];
    const optedPartnerOffersByEmail = userRegistrationData[formConstants.acceptOffers];
    const preferenceCentre =
        getPreferenceCentreBasedOnOptIns(accountData.preferences, optedTheOpenOffersByEmail, optedPartnerOffersByEmail);

    const user = {
        membership,
        title: userRegistrationData[formConstants.title],
        email: getFormattedEmailRemoveSpaces(userRegistrationData[formConstants.emailAddress]),
        firstName: userRegistrationData[formConstants.firstName],
        lastName: userRegistrationData[formConstants.lastName],
        addresses: copyOfAccountData.addresses,
        raMemberId: copyOfAccountData.raMemberId,
        mobilePhone: getMobilePhone(userRegistrationData),
        countryCodeMobilePhonePrefix: getCountryCodeMobilePhonePrefix(userRegistrationData),
        currentWebsite: userRegistrationData[formConstants.ssoDomain],
        dateOfBirth: userRegistrationData[formConstants.dateOfBirth] ?
            getDateAsISOString(userRegistrationData[formConstants.dateOfBirth]) :
            null,
        interests: copyOfAccountData.interests,
        optIns: {
            optedTheOpenOffersByEmail,
            optedPartnerOffersByEmail,
            agreedToTermsAndConditions: accountData.optIns.agreedToTermsAndConditions,
            agreedToPrivacyPolicy: userRegistrationData[formConstants.privacyPolicy]
        },
        preferences: preferenceCentre,
    };

    return { user };
}

export function getFormattedUserSignInDetailsData(lastLoginDate, lastLoginDevice, lastLoginPlatform) {
    return { LastLogInDate: lastLoginDate, LastLogInDevice: lastLoginDevice, LastLogInPlatform: lastLoginPlatform };
}

export function getBallotFormattedUserDetailsData(userRegistrationData, accountData) {
    const { membership, email } = accountData;
    const copyOfAccountData = deepCopyObject(accountData);
    const formType = userRegistrationData[formConstants.formType] == null ? ssoFormTypes.BallotSummaryForm : userRegistrationData[formConstants.formType];
    const reCaptcha = userRegistrationData[formConstants.reCaptcha];
    copyOfAccountData.addresses = updateMainAddress(userRegistrationData, copyOfAccountData.addresses);

    const optedTheOpenOffersByEmail = !userRegistrationData[formConstants.refuseOffers];
    const optedPartnerOffersByEmail = userRegistrationData[formConstants.acceptOffers];
    const preferenceCentre =
        getPreferenceCentreBasedOnOptIns(accountData.preferences, optedTheOpenOffersByEmail, optedPartnerOffersByEmail);

    const activeMemberships = getActiveMemberships(membership);
    let uniqueMemberships = addMembershipType(activeMemberships, MembershipTypes.OneClub);

    if (userRegistrationData.mastercard) {
        uniqueMemberships = addMembershipType(activeMemberships, MembershipTypes.OneClubAdvantage);
    }

    const user = {
        membership: uniqueMemberships,
        title: getValueOrDefault(userRegistrationData[formConstants.title]),
        email: email.toLowerCase(),
        firstName: userRegistrationData[formConstants.firstName],
        lastName: userRegistrationData[formConstants.lastName],
        addresses: copyOfAccountData.addresses,
        raMemberId: copyOfAccountData.raMemberId,
        mobilePhone: getMobilePhone(userRegistrationData),
        countryCodeMobilePhonePrefix: getCountryCodeMobilePhonePrefix(userRegistrationData),
        currentWebsite: userRegistrationData[formConstants.ssoDomain],
        dateOfBirth: userRegistrationData[formConstants.dateOfBirth] ?
            getDateAsISOString(userRegistrationData[formConstants.dateOfBirth]) :
            null,
        interests: copyOfAccountData.interests,
        optIns: {
            optedTheOpenOffersByEmail,
            optedPartnerOffersByEmail,
            agreedToTermsAndConditions: userRegistrationData[formConstants.oneClubTermsAndServices],
            agreedToPrivacyPolicy: userRegistrationData[formConstants.oneClubTermsAndServices]
        },
        preferences: preferenceCentre,
    };

    return { formType, reCaptcha, user };
}

export function getRaMembersFormattedUserDetailsData(userRegistrationData, accountData) {
    const { membership, email } = accountData;
    const copyOfAccountData = deepCopyObject(accountData);

    copyOfAccountData.addresses = updateMainAddress(userRegistrationData, copyOfAccountData.addresses);

    const optedTheOpenOffersByEmail = !userRegistrationData[formConstants.refuseOffers];
    const optedPartnerOffersByEmail = userRegistrationData[formConstants.acceptOffers];
    const preferenceCentre =
        getPreferenceCentreBasedOnOptIns(accountData.preferences, optedTheOpenOffersByEmail, optedPartnerOffersByEmail);

    const activeMemberships = getActiveMemberships(membership);
    const uniqueMemberships = addMembershipType(activeMemberships, MembershipTypes.OneClub);

    const user = {
        membership: uniqueMemberships,
        title: getValueOrDefault(userRegistrationData[formConstants.title]),
        email: email.toLowerCase(),
        firstName: userRegistrationData[formConstants.firstName],
        lastName: userRegistrationData[formConstants.lastName],
        addresses: copyOfAccountData.addresses,
        raMemberId: userRegistrationData.raMemberId,
        mobilePhone: getMobilePhone(userRegistrationData),
        countryCodeMobilePhonePrefix: getCountryCodeMobilePhonePrefix(userRegistrationData),
        currentWebsite: userRegistrationData[formConstants.ssoDomain],
        dateOfBirth: userRegistrationData[formConstants.dateOfBirth] ?
            getDateAsISOString(userRegistrationData[formConstants.dateOfBirth]) :
            null,
        interests: copyOfAccountData.interests,
        optIns: {
            optedTheOpenOffersByEmail,
            optedPartnerOffersByEmail,
            agreedToTermsAndConditions: userRegistrationData[formConstants.oneClubTermsAndServices],
            agreedToPrivacyPolicy: userRegistrationData[formConstants.oneClubTermsAndServices]
        },
        preferences: preferenceCentre,
    };

    return { user };
}

function getValueOrDefault(title) {
    if (isEmpty(title.defaultValue)) { return title; }

    return title.defaultValue;
}

export function getFormattedJoinTheOneClubData(userRegistrationData, accountData) {
    const { membership, becomeOneClubMember } = userRegistrationData;
    const copyOfAccountData = deepCopyObject(accountData);
    const activeMemberships = getActiveMemberships(membership);
    let isOneClubMember = membership.includes(MembershipTypes.OneClub);

    copyOfAccountData.addresses = updateMainAddressToJoinOneClub(userRegistrationData, copyOfAccountData.addresses);

    const user = {
        membership,
        title: userRegistrationData[formConstants.title],
        email: getFormattedEmailRemoveSpaces(accountData[formConstants.email]),
        firstName: accountData[formConstants.firstName],
        lastName: accountData[formConstants.lastName],
        addresses: copyOfAccountData.addresses,
        raMemberId: accountData.raMemberId,
        mobilePhone: accountData.mobilePhone,
        countryCodeMobilePhonePrefix: accountData.countryCodeMobilePhonePrefix,
        dateOfBirth: userRegistrationData[formConstants.dateOfBirth] ?
            getDateAsISOString(userRegistrationData[formConstants.dateOfBirth]) :
            accountData.dateOfBirth,
        optIns: {
            optedTheOpenOffersByEmail: accountData.optIns.optedTheOpenOffersByEmail,
            optedPartnerOffersByEmail: accountData.optIns.optedPartnerOffersByEmail,
            agreedToTermsAndConditions: userRegistrationData[formConstants.oneClubTermsAndServices],
            agreedToPrivacyPolicy: userRegistrationData[formConstants.oneClubTermsAndServices] === true ? userRegistrationData[formConstants.oneClubTermsAndServices] : accountData.optIns.agreedToPrivacyPolicy
        },
        preferences: accountData.preferences
    };

    if (!becomeOneClubMember && isOneClubMember) {
        isOneClubMember = false;
        const oneClubIndex = activeMemberships.indexOf(MembershipTypes.OneClub);
        activeMemberships.splice(oneClubIndex, 1);
        user.membership = activeMemberships.join(';');
    }

    if (becomeOneClubMember && !isOneClubMember) {
        isOneClubMember = true;
        activeMemberships.push(MembershipTypes.OneClub);
        user.membership = activeMemberships.join(';');
    }

    user.interests = updateInterests(userRegistrationData, user.interests);

    return { user };
}

function getActiveMemberships(membership) {
    return membership.split(';');
}

export function getFormattedNotificationSettingsData(userRegistrationData, accountData) {
    const channels = getChannelInterests(userRegistrationData);

    const optedTheOpenOffersByEmail = getOptInBasedOnChannels(accountData.optIns.optedTheOpenOffersByEmail, channels);
    const optedPartnerOffersByEmail = getOptInPartnersBasedOnChannels(accountData.optIns.optedPartnerOffersByEmail, channels);

    const user = {
        optIns: {
            optedTheOpenOffersByEmail,
            optedPartnerOffersByEmail
        },
        preferences: {
            championships: getChampionshipInterests(userRegistrationData),
            channels,
            interests: getUserInterests(userRegistrationData)
        }
    };

    return user;
}

function getOptInBasedOnChannels(optInValue, channels) {
    let value = false;

    Object.keys(channels).forEach((key) => {
        if (channels[key]) value = true;
    });

    return value;
}

function getOptInPartnersBasedOnChannels(optInValue, channels) {
    let value = false;

    Object.keys(channels).forEach((key) => {
        if (channels[key]) { value = optInValue; }
    });

    return value;
}

function getDefaultChampionships(userRegistrationData) {
    const { championshipSection } = userRegistrationData.ssoEmailNotificationSettingsFields;
    const { choices } = championshipSection;

    return choices.map((element) => {
        return {
            id: element.id,
            value: true
        };
    });
}

function getDefaultInterests(userRegistrationData) {
    const { interestsSection } = userRegistrationData.ssoEmailNotificationSettingsFields;
    const { choices } = interestsSection;

    const obj = {};

    choices.forEach((element) => {
        obj[element.id] = true;
    });

    return obj;
}

function getChampionshipInterests(userRegistrationData) {
    const { championshipSection } = userRegistrationData;
    const { choices, defaultValue } = userRegistrationData.formData.championshipSection;

    return choices.map((element) => {
        return {
            Id: element.id,
            Value: isInSelection(element.id, championshipSection, defaultValue)
        };
    });
}

function isInSelection(id, array, defaultValue) {
    let selectedValue = [];

    if (array != null) { selectedValue = array; } else {
        selectedValue = defaultValue;
    }

    if (selectedValue == null) { return false; }

    const item = selectedValue.find((o) => o.toUpperCase() === id.toUpperCase());

    return !(item == null);
}

function getChannelInterests(userRegistrationData) {
    const { channelSection } = userRegistrationData;
    const { choices, defaultValue } = userRegistrationData.formData.channelSection;

    const obj = {};

    choices.forEach((element) => {
        obj[element.id] = isInSelection(element.id, channelSection, defaultValue);
    });

    return obj;
}

function getUserInterests(userRegistrationData) {
    const { interestSection } = userRegistrationData;
    const { choices, defaultValue } = userRegistrationData.formData.interestSection;

    const obj = {};

    choices.forEach((element) => {
        obj[element.id] = isInSelection(element.id, interestSection, defaultValue);
    });

    return obj;
}

function getPreferenceCentreBasedOnOptIns(preferences, optedTheOpenOffersByEmail,
    optedPartnerOffersByEmail) {
    if (optedPartnerOffersByEmail) { return getPreferencesForOptIn(preferences); }

    if (optedTheOpenOffersByEmail) { return preferences; }

    if (preferences.channels == null) { return preferences; }

    preferences = getPreferencesForOptOut(preferences);

    return preferences;
}

function getPreferencesForOptOut(preferences) {
    Object.keys(preferences.channels).forEach((key) => {
        if (preferences.channels[key] === true) { preferences.channels[key] = false; }
    });

    return preferences;
}

function getPreferencesForOptIn(preferences) {
    Object.keys(preferences.channels).forEach((key) => {
        preferences.channels[key] = true;
    });

    return preferences;
}

function updateMainAddress(userRegistrationData, addresses) {
    if (isEmpty(addresses)) {
        addresses = [];
    }

    let mainAddress = addresses.find((address) => address.main);
    const isNewAddress = isEmpty(mainAddress);
    const mainAddressIndex = isNewAddress ? 0 : getAddressIndex(mainAddress, addresses);

    mainAddress = {
        addressLine1: userRegistrationData[formConstants.addressLine1],
        addressLine2: userRegistrationData[formConstants.addressLine2],
        addressLine3: userRegistrationData[formConstants.addressLine3],
        postcode: userRegistrationData[formConstants.postcode],
        city: userRegistrationData[formConstants.city],
        country: userRegistrationData[formConstants.country],
        county: userRegistrationData[formConstants.county],
        state: userRegistrationData[formConstants.state],
        main: isNewAddress ? true : mainAddress.main,
        shippingAddress: isNewAddress ? true : mainAddress.shippingAddress,
        billingAddress: isNewAddress ? true : mainAddress.billingAddress
    };

    addresses[mainAddressIndex] = mainAddress;
    return addresses;
}

function updateMainAddressToJoinOneClub(userRegistrationData, addresses) {
    if (isEmpty(addresses)) {
        addresses = [];
    }

    let mainAddress = addresses.find((address) => address.main);
    const isNewAddress = isEmpty(mainAddress);
    const mainAddressIndex = isNewAddress ? 0 : getAddressIndex(mainAddress, addresses);
    mainAddress = isNewAddress ? {} : mainAddress;

    mainAddress = {
        addressLine1: mainAddress[formConstants.addressLine1],
        addressLine2: mainAddress[formConstants.addressLine2],
        addressLine3: mainAddress[formConstants.addressLine3],
        postcode: userRegistrationData[formConstants.postcode],
        city: mainAddress[formConstants.city],
        country: userRegistrationData[formConstants.country],
        county: userRegistrationData[formConstants.county],
        state: userRegistrationData[formConstants.state],
        main: isNewAddress ? true : mainAddress.main,
        shippingAddress: isNewAddress ? true : mainAddress.shippingAddress,
        billingAddress: isNewAddress ? true : mainAddress.billingAddress
    };

    addresses[mainAddressIndex] = mainAddress;
    return addresses;
}

function getAddressIndex(addressForFind, addresses) {
    const addressForFindJSON = JSON.stringify(addressForFind);
    let addressIndex = -1;

    if (isEmpty(addresses)) {
        return -1;
    }

    addresses.forEach((address, index) => {
        if (addressForFindJSON === JSON.stringify(address)) {
            addressIndex = index;
        }
    });

    return addressIndex;
}

export function getFormattedOrders(orders) {
    return orders.map((order) => {
        if (isEmpty(order.lastUpdate)) {
            order.formattedLastUpdate = formMessageConstants.emptyString;
            return order;
        }
        const lastUpdateDate = createDateFromExisting(order.lastUpdate);
        order.formattedLastUpdate = getFormattedDate(lastUpdateDate);
        order.formattedFileAmount = getFormattedMonetaryAmount(order.fileAmount);
        order.orderTypeIndex = orderType[order.orderType];
        order.fileStateIndex = fileState[order.status];
        return order;
    });
}

export function getFormattedHomePageTicketsData(ticketsData, ssoDomain) {
    ticketsData.actionItems = isEmpty(ticketsData.actionItems) ? [] : ticketsData.actionItems.map((actionItem) => {
        if (ssoDomain === domainConstants.theOpen &&
            orderType[actionItem.orderType] === orderType.SALE &&
            fileState[actionItem.fileState] === fileState.IN_RESERVATION) {
            actionItem.orderTypeIndex = orderType.RESERVATION;
        } else {
            actionItem.orderTypeIndex = orderType[actionItem.orderType];
        }
        return actionItem;
    });

    if (_.isEmpty(ticketsData.lastOrder)) {
        ticketsData.lastOrder = {
            orderType: formMessageConstants.defaultNumberValue,
            fileStateIndex: formMessageConstants.defaultNumberValue,
            formattedFileAmount: formMessageConstants.defaultNumberValue
        };
    }

    ticketsData.lastOrder.orderTypeIndex = orderType[ticketsData.lastOrder.orderType];
    ticketsData.lastOrder.fileStateIndex = fileState[ticketsData.lastOrder.status];
    ticketsData.lastOrder.formattedFileAmount = getFormattedMonetaryAmount(ticketsData.lastOrder.fileAmount);
    return ticketsData;
}

export function getFormattedOrderDetails(orderDetails) {
    orderDetails.formattedFileAmount = getFormattedMonetaryAmount(orderDetails.fileAmount);
    orderDetails.orderTypeIndex = orderType[orderDetails.orderType];

    if (!isEmpty(orderDetails.paymentSummary)) {
        orderDetails.paymentSummary.formattedTotalAmountPaid = getFormattedMonetaryAmount(orderDetails.paymentSummary.totalAmountPaid);
        orderDetails.paymentSummary.formattedAmountInvoiced = getFormattedMonetaryAmount(orderDetails.paymentSummary.amountInvoiced);
        orderDetails.paymentSummary.formattedLastPaymentDate = getFormattedDate(orderDetails.paymentSummary.lastPaymentDate);
        orderDetails.paymentSummary.installments = orderDetails.paymentSummary.installments.map((installment) => {
            installment.formattedDueDate = getFormattedDate(installment.dueDate);
            installment.formattedAmountDue = getFormattedMonetaryAmount(installment.amountDue);
            installment.formattedAmountPaid = getFormattedMonetaryAmount(installment.amountPaid);
            return installment;
        });
    }

    orderDetails.delivery = isEmpty(orderDetails.delivery) ? {} : orderDetails.delivery;

    orderDetails.history = isEmpty(orderDetails.history) ? [] : orderDetails.history.map((currentHistory) => {
        currentHistory.formattedConfirmed = getFormattedMonetaryAmount(currentHistory.confirmed);
        currentHistory.formattedOpen = getFormattedMonetaryAmount(currentHistory.open);
        currentHistory.orderTypeIndex = orderType[currentHistory.orderType];
        return currentHistory;
    });

    orderDetails.files = isEmpty(orderDetails.files) ? [] : orderDetails.files.map((file) => {
        file.formattedTotalAmount = getFormattedMonetaryAmount(file.total);
        file.fileContentItems = file.fileContentItems.map((fileContentItem) => {
            fileContentItem.formattedUnitPrice = getFormattedMonetaryAmount(fileContentItem.unitPrice);
            fileContentItem.formattedSubTotal = getFormattedMonetaryAmount(fileContentItem.subtotal);
            return fileContentItem;
        });
        return file;
    });

    return orderDetails;
}

export function getFormattedMonetaryAmount(amount) {
    const amountToFormat = amount || 0;
    return new Intl.NumberFormat('en', {
        style: 'currency',
        currency: currencyIsoCodes.GBP
    }).format(amountToFormat);
}

export function getFormattedDate(date) {
    if (isEmpty(date)) {
        return formMessageConstants.emptyString;
    }

    const dateToFormat = createDateFromExisting(date);
    return new Intl.DateTimeFormat(formDateConstants.region, formDateConstants.options).format(dateToFormat);
}

export function getFormattedVerifyEmailData(verifyEmailData) {
    return verifyEmailData[formConstants.verificationCode];
}

function getCountryCodeMobilePhonePrefix(data) {
    return data[formConstants.mobilePhone] && data[formConstants.mobilePhone].selectedCountry ? data[formConstants.mobilePhone].selectedCountry.code : formMessageConstants.emptyString;
}

function getMobilePhone(data) {
    return data[formConstants.mobilePhone] && data[formConstants.mobilePhone].selectedCountry && !isEmpty(data[formConstants.mobilePhone].phoneNumber) ?
        `${data[formConstants.mobilePhone].selectedCountry.phonePrefix}${data[formConstants.mobilePhone].phoneNumber}` : formMessageConstants.emptyString;
}

export function getFormattedUserDetailsAddressesData(userDetails) {
    userDetails.dateOfBirth = getDateAsISOString(userDetails[formConstants.dateOfBirth]);
    return { user: userDetails };
}

export function getFormattedEmailRemoveSpaces(email) {
    const value = isEmpty(email.defaultValue) ? email : email.defaultValue;

    const formattedEmail = value.replace(/ /g, '');

    return formattedEmail.toLowerCase();
}

export function getFormattedSaveUserToAddressBookRequest(formData = {}, accountData = {}) {
    if (!hasValue(formData) || !hasValue(accountData)) {
        return undefined;
    }

    const { dotDigitalAddressBookData } = formData;
    const { email } = accountData;

    const formattedUserDetails = getUserDetailsForSaveToAddressBookRequest(accountData);

    return getSaveUserToAddressBookRequestModel(formattedUserDetails, email, dotDigitalAddressBookData);
}

function addMembershipType(activeMemberships, membershipToAdd) {
    if (!activeMemberships.includes(membershipToAdd)) { activeMemberships.push(membershipToAdd); }

    const uniqueMemberships = activeMemberships.filter((v, i) => activeMemberships.indexOf(v) === i);

    const newMemberships = uniqueMemberships.join(';');

    return newMemberships;
}

function getUserZoneInfo(registerFormData) {
    if (registerFormData) { return registerFormData.zoneInfo; }

    return null;
}

function getUpgradeToOneClubFormType(userDetails) {
    const { activeMemberships } = userDetails;
    const userDetailsFormType = get(userDetails, formConstants.formType, null);

    if (hasValue(activeMemberships) && isNullOrUndefined(userDetailsFormType)) {
        const computedFormType = userService.hasTicketingAccount(userDetails) ?
            ssoFormTypes.UpgradeToOneClubAccountFromTicketing :
            ssoFormTypes.UpgradeToOneClubAccountFromDefault;

        return computedFormType;
    }

    return userDetailsFormType;
}
